import { AvatarType, FootageRequirements, RecordingTimes } from '@/pages/avatar/common/types';

type AvatarTypeFootageRequirements = Record<AvatarType, FootageRequirements>;
const EXPRESS_MIN_FOOTAGE_DURATION = 30;
const EXPRESS_MAX_FOOTAGE_DURATION = 300;
export const AvatarTypeToFootageRequirements: AvatarTypeFootageRequirements = {
    [AvatarType.Express]: {
        maxFileSizeInMB: 2 * 1024,
        minFileDurationInSeconds: EXPRESS_MIN_FOOTAGE_DURATION,
        maxFileDurationInSeconds: EXPRESS_MAX_FOOTAGE_DURATION + 15,
        uploadFootageSubtext: '30 sec - 5 mins, MP4, MOV, up to 2GB',
    },
    [AvatarType.PremiumPlus]: {
        maxFileSizeInMB: 2 * 1024,
        minFileDurationInSeconds: 200,
        maxFileDurationInSeconds: 600,
        uploadFootageSubtext: '3:30 mins, MOV, MP4, WEBM, up to 2GB',
        minResolution: 0.5,
    },
};

type AvatarTypeRecordingTime = Record<AvatarType, RecordingTimes>;

export const AvatarTypeToRecordingTimes: AvatarTypeRecordingTime = {
    [AvatarType.Express]: {
        minRecordingTime: EXPRESS_MIN_FOOTAGE_DURATION,
        recordingTime: EXPRESS_MAX_FOOTAGE_DURATION,
    },
    [AvatarType.PremiumPlus]: {
        minRecordingTime: 300,
        recordingTime: 300,
    },
};

export const AvatarIdleGuidance = '<Look at the camera with a natural smile and breath.>';
export const AvatarIdlePeriod = 30;
